module.exports = __webpack_public_path__ + "media/images/front/company/company_2-30026ba73e1cc63d0aecb80fad998a6f.jpg";